import { Injectable } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { ApiService } from 'app/shared/services/api.service';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { SupplierTaskDetail, SupplierTaskResponse, SupplierTaskStep,TaskTimTrackModel } from '../models/suppliertasks.model';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class SupplierTaskService extends BaseService {
  constructor(private apiService: ApiService, private http: HttpClient, private config: AppSettings) {
    super();
  }

  getToDoTaskCount(): Observable<number> {
    return this.apiService.get(`${this.config.SRM_API_URL}Task/to-do-count`);
  }

  getSupplierTaskStep(supplierCode: string, taskId: number, type: string): Observable<SupplierTaskStep> {
    return this.apiService.get(`${this.config.BaseUrl}Profile/Onboarding/${supplierCode}/${taskId}/${type}`);
  }

  postSupplierTaskStepResponse(supplierCode: string, taskResponse: SupplierTaskResponse): Observable<boolean> {
    return this.apiService.post(`${this.config.BaseUrl}Profile/Onboarding/${supplierCode}/Task/Resolve`, taskResponse)
  }

  getSupplierTasks(supplierCode: string, taskId?: number): Observable<SupplierTaskDetail[]> {
    let query = taskId > 0 ? `?taskId=${taskId}` : '';
    return this.apiService.get(`${this.config.BaseUrl}Profile/Onboarding/${supplierCode}${query}`).pipe(
      map((tasks: SupplierTaskDetail[]) => {
        return tasks.map(task => {
          task.disabled = (task.subTaskType == "Bank" || task.subTaskType == "BankList") && ['new', 'rejected', 'inprogress', 'pending'].includes(task.taskStatus.toLowerCase()) && tasks?.find(x => x.subTaskType.toLowerCase() === "details" && ['new', 'rejected', 'inprogress', 'pending'].includes(x.taskStatus.toLowerCase())) != undefined;
          return task;
        });
      })
    );;
  }
  
  postTaskTimeTrack(portalTaskID: string, supplierCode: string, subTaskType: string, timeTrackType: string):Observable<any> { 
    var timetrackdata: TaskTimTrackModel = {
      portalTaskID: portalTaskID,
      supplierCode: supplierCode,
      subTaskType: subTaskType,
      timeTrackType: timeTrackType
    }
    const url = `${this.config.BaseUrl}Profile/Onboarding/PostTimeTrack`;
    return this.http.post(url, timetrackdata, { headers: this.setHeaders() });
  }
}
